import {pub, sub} from './pubsub.js'
import tab from './tab'
function focusCurrent() {
    pub("termFocusCurrent")
}
function focusCurrentAddCallback(cb) {
    sub("termFocusCurrent", cb)
}

function tipsUpdateSelectedBytes(tabID, selectedBytes) {
    // console.log(`tabTipsUpdate call by: ${caller}, tips: ${tips}`)
    if (tabID !== tab.curTabKey) {
        console.log("tipsUpdateSelectedBytes: receive update selected bytes info from tab which is NOT current tab")
        return
    }
    pub("termTipsUpdateSelectedBytes", selectedBytes)
}
function tipsUpdateSelectedBytesAddCallback(cb) {
    sub("termTipsUpdateSelectedBytes", cb)
}

function exportCurLog() {
    pub("termExportCurTermLog")
}

function exportCurLogAddCallback(cb) {
    sub("termExportCurTermLog", cb)
}

function printCurLog() {
    pub("termPrintCurLog")
}

function printCurLogAddCallback(cb) {
    sub("termPrintCurLog", cb)
}

export default {
    focusCurrent,
    focusCurrentAddCallback,
    tipsUpdateSelectedBytes,
    tipsUpdateSelectedBytesAddCallback,
    exportCurLog,
    exportCurLogAddCallback,
    printCurLog,
    printCurLogAddCallback,
}
